export const enum Products {
  Showcase = 'Showcase',
  Boost = 'Boost',
}
